import { Box } from '@mui/material'
import OnboardingIcon from 'assets/icons/icon-onboarding.svg?react'
import { CheckCircleOutline } from '@mui/icons-material'
import { alpha, styled, useTheme } from '@mui/material/styles'
import { OnboardingChecklistProgressProps } from '../types'
import { useBranding } from 'features/branding/hooks/brandingHooks'
import { Typography } from '@carto/meridian-ds/components'

const Root = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}))

const OnboardingStartIcon = styled(OnboardingIcon)(() => ({
  opacity: 0.4
}))

const ProgressCircle = styled(Box, {
  shouldForwardProp: (prop: string) => !['completedPercentage', 'color'].includes(prop)
})<{
  completedPercentage?: number
  color?: string
}>(({ theme, completedPercentage, color }) => ({
  position: 'relative',
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  background: `conic-gradient(${color} calc(${completedPercentage}*1%), ${alpha(theme.palette.common.white, 0.4)} 0%)`,
  borderRadius: '50%',

  '&::before': {
    position: 'absolute',
    borderRadius: '50%',
    content: '""',
    top: 2,
    left: 2,
    right: 2,
    bottom: 2,
    background: theme.palette.brand.appBarMain,
    zIndex: 3
  }
}))

export function OnboardingChecklistTrigger({ completed, total, completedTotal }: OnboardingChecklistProgressProps) {
  const completedPercentage = (completedTotal * 100) / total
  const theme = useTheme()
  const { data: branding } = useBranding()
  const isUsingCustomColor =
    branding.usePrimaryColorsForAppBar || branding.appBarBackgroundColor !== theme.palette.brand.navyBlue

  return (
    <Root aria-label="onboarding-checklist-trigger">
      {completed && <CheckCircleOutline className="doNotFillIcon" />}
      {!completed && completedTotal > 0 && (
        <ProgressCircle
          completedPercentage={completedPercentage}
          color={isUsingCustomColor ? theme.palette.brand.appBarContrastText : theme.palette.secondary.main}
        />
      )}
      {!completed && completedTotal === 0 && <OnboardingStartIcon className="doNotFillIcon" />}

      <Typography variant="caption" weight="medium" ml={0.5}>
        {`${completedTotal}/${total}`}
      </Typography>
    </Root>
  )
}

export default OnboardingChecklistTrigger
